import { AxiosError } from 'axios';
import { GET_GSC_CHECK_EXISTING_DRAFT_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { GET_GSC_CHECK_EXISTING_DRAFT_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CheckExistingDraftResponse {
  uuid: string;
  applicationId: string;
  examLevel: string;
  draft: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  groupScType: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetCheckExistingDraft = ({ groupScType, onSuccess, onError, enabled }: Input) => {
  const getCheckExistingDraft = async () => {
    const res = await axiosClient.get<CheckExistingDraftResponse>(
      GET_GSC_CHECK_EXISTING_DRAFT_URL(groupScType)
    );
    return res.data;
  };

  return useCustomQuery(GET_GSC_CHECK_EXISTING_DRAFT_QUERY_KEY, getCheckExistingDraft, {
    onSuccess,
    onError,
    enabled,
  });
};
